module.exports = __webpack_public_path__ + "img/LikesIcon.f6474498.svg";